import type { IAvatarProps } from '@sixui/ui';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Anchored, Avatar } from '@sixui/ui';

import type { IApiGetUserResponseBody } from '~/lib/api/modules/Users';
import { parseUserInfo } from '~/helpers/parseUserInfo';

export type IUserAvatarProps = IAvatarProps & {
  user?: IApiGetUserResponseBody;
  isSuperAdmin?: boolean;
};

export const UserAvatar: React.FC<IUserAvatarProps> = (props) => {
  const { user, isSuperAdmin, children, ...other } = props;
  const userInfo = user ? parseUserInfo(user) : undefined;

  const renderAvatar = (): JSX.Element => (
    <Avatar
      variant="rounded"
      fallbackToRandomColor
      randomColorSourceString={userInfo?._id}
      src={userInfo?.avatarUrl}
      {...other}
    >
      {children ?? userInfo?.initials}
    </Avatar>
  );

  return isSuperAdmin ? (
    <Anchored
      content={<FontAwesomeIcon icon={faShieldHalved} />}
      overlap="circular"
    >
      {renderAvatar()}
    </Anchored>
  ) : (
    renderAvatar()
  );
};
